// extracted by mini-css-extract-plugin
export default {"content":"style_content__V-my0","checkbox":"style_checkbox__o4CSP"};